// extracted by mini-css-extract-plugin
module.exports = {"block":"i_eF","label":"i_eG","iconContainer":"i_eH","icon":"i_eI","active":"i_eJ"};